import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestSalaryAdvanceListService = (
  params: Types.ApprovalRequestSalaryAdvanceListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryAdvanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestSalaryAdvanceCreateService = (
  params: Types.ApprovalRequestSalaryAdvanceCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestSalaryAdvanceUpdateService = (
  params: Types.ApprovalRequestSalaryAdvanceUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestSalaryAdvanceDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryAdvance>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestSalaryAdvanceApproveService = (
  params: Types.ApprovalRequestSalaryAdvanceApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestSalaryAdvance>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
